export { default } from './GuidesWidget'
export * from './GuidesWidget'
